<nz-layout [class]="currentURL">
  <nz-header>
    <img src="assets/logo-divemotor.svg" alt="Logo Divemotor" *ngIf="currentURL==='divemotor-style'">
    <img src="assets/logo-andesmotor.svg" alt="Logo Andesmotor" *ngIf="currentURL==='andesmotor-style' && !isOriente">
    <img src="assets/logo-andesmotor-oriente.png" alt="Logo Andesmotor Oriente" *ngIf="currentURL==='andesmotor-style' && isOriente">
  </nz-header>
  <nz-content style="min-height:calc(100vh - 64px)" [class]="currentURL">
    <router-outlet></router-outlet>
  </nz-content>
</nz-layout>